module.exports = __webpack_public_path__ + "media/images/instagram-916ff63340ae3eddbaa06576eee875d9.svg";